import { render, staticRenderFns } from "./PruebaChatbot.vue?vue&type=template&id=626cd353&"
import script from "./PruebaChatbot.vue?vue&type=script&lang=js&"
export * from "./PruebaChatbot.vue?vue&type=script&lang=js&"
import style0 from "./PruebaChatbot.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports